import * as yup from "yup"
import { formSalesOrderDetailSchema } from "pages/Sales/Transaction/CustomerOrder/types"

export type FormInvoiceDetailType = yup.InferType<
  typeof formInvoiceDetailSchema
>

export const formInvoiceDetailSchema = formSalesOrderDetailSchema.shape({
  quantity_invoice: yup
    .number()
    .min(1).label('Qty')
    .test(
      "is-not-larger-than-back_order",
      "Quantity Invoice cannot be larger than Qty Back Order",
      function (value) {
        const { qty_order } = this.parent
        const { received } = this.parent
        const back_order = qty_order - received
        if (back_order && value && value > back_order) {
          return false
        }
        return true
      }
    ),
  invoice_id: yup.number().nullable(),
  invoice_detail_id: yup.number().nullable(),
  project_id: yup.number().label("Project").typeError("Project is required").required(),
  project_name: yup.string().label("Project").optional(),
  product_foto: yup.string().label("Product Foto").optional().nullable(),
})
